module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp1"
  }), _vm._v(" "), _c('p', {
    staticClass: "FMH"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "sp1"
  }), _vm._v(" "), _c('p', {
    staticClass: "CCT-F"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/title#tit",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT-F"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyrightnotice#notice",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Notice")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT-F"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/dedication#ded",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dedication")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT-F"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/epigraph#epig"
    }
  }, [_vm._v("Epigraphs")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT-F"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/introduction#intro"
    }
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT-F"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/prologue#prol"
    }
  }, [_vm._v("Prologue")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT-1"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("1. "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter1#ch1"
    }
  }, [_vm._v("The Portugee from New Bedford")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT-1"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("2. "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter2#ch2"
    }
  }, [_vm._v("An Animal Is Born")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT-1"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("3. "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter3#ch3"
    }
  }, [_vm._v("A Rising Star")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT-1"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("4. "), _c('a', {
    attrs: {
      "href": "#/xhtml/chapter4#ch4"
    }
  }, [_vm._v("The Pax Patriarca")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT-1"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("5. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter5#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Wild Bunch")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT-1"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("6. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter6#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bear and the Rifleman")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT-1"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("7. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter7#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Man at the Top of Winter Hill")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT-1"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("8. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter8#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bastard Should Get a Medal")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT-1"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("9. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter9#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("This Bunch of Bookies")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("10. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter10#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Duke of Medford")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("11. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter11#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Uneasy Lies the Head")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("12. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter12#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Into the Public Eye")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("13. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter13#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bodies Start Falling")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("14. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter14#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Four Salesmen and a Spaniard")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("15. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter15#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("City on Fire")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("16. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter16#ch16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Irish Luck")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("17. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter17#ch17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("An Alley in Chelsea")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("18. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter18#ch18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Price of a Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("19. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter19#ch19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Town without Pity")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("20. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter20#ch20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The McLaughlins’ Last Stand")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("21. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter21#ch21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A City Almost Stilled")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("22. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter22#ch22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hat Trick")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("23. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter23#ch23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Biggest Squeeze")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("24. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter24#ch24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Worst-Laid Plans")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("25. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter25#ch25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Office Door Slams")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("26. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter26#ch26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Don at Bay")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("27. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter27#ch27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Noose Tightens")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("28. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter28#ch28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Baron’s Isle")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("29. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter29#ch29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Change in Ownership")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("30. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter30#ch30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Bomb")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("31. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter31#ch31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Animal Loosed Again")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("32. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter32#ch32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The New Life")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("33. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter33#ch33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Confederacy of Dunces")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("34. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter34#ch34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cornered")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("35. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter35#ch35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Golden State")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT1"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("36. "), _c('span', {
    attrs: {
      "href": "#/xhtml/chapter36#ch36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Back Inside")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT-B"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/epilogue#epil",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: “What Goes Around…”")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT-B"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/notes#note",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Source Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT-B"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography#bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selected Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT-B"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index#index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT-B"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/photo1#photo1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Photographs")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT-B"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/adcard#adcard",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Also by Marc Songini")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT-B"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/abouttheauthor#about",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])]), _vm._v(" "), _c('p', {
    staticClass: "CCT-B"
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/copyright#crt",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2176abdc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 66
// module chunks = 0